import "./projects.css"

function Projects() {
    return (
        <div>
            <p>Two cool projects exist:</p>
            <p><a href="https://watchparty.kp-dev.de">Watchparty-Bingo</a></p>
            <p><a href="https://quiz.kp-dev.de">1%-Quiz Tracker</a></p>
            <p><a href="https://tipp.kp-dev.de" >WM-Tippspiel</a></p>
        </div>
    );
}

export default Projects;